import { passkeyClient } from "@better-auth/passkey/client";
import { emailOTPClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { API_URL } from "@/lib/api-url";

/**
 * Passwordless, like maquette (AUTH.md): a 6-digit code by email (sign-in and sign-up are the
 * same flow) or a passkey. Workspaces come from the organization plugin.
 */
export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: "/api/auth",
  plugins: [emailOTPClient(), passkeyClient(), organizationClient()],
});

export const { useSession, signOut } = authClient;
